
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { fetcher } from 'api/client';
import { createWalletFromFiel, importWallet } from 'api/actions/eip712';
import bootbox from 'components/Modals/Bootbox';
import clsx from 'clsx';
import { Button, FormGroup, Input } from 'reactstrap';

export default function WalletFiel() {

    const { t } = useTranslation();

    const queryClient = useQueryClient();
    const form = useRef(null);
    const address = useRef(null);

    const onSuccess = async (data) => {
        await queryClient.invalidateQueries('profile');
        queryClient.invalidateQueries('get-wallets');
        form.current.reset();
    };

    const onError = (error) => {
        bootbox.alert(t(`errors.${error.message}`, t('errors.GeneralError')));
    };

    const { mutate: createWalletMutation, isLoading } = useMutation((payload) => fetcher(createWalletFromFiel(payload)), {
        onSuccess,
        onError
    });

    const { mutate: importWalletMutation } = useMutation((payload) => fetcher(importWallet(payload)), {
        onSuccess,
        onError
    })

    const doCreateWallet = (e) => {
        e.preventDefault();
        createWalletMutation(new FormData(form.current));
    }

    const importAddress = () => {
        importWalletMutation({ address: address.current.value })
    }

    return (
        <div>
            <form ref={form} onSubmit={doCreateWallet}>
                <h5>{t('blockchain.create_fiel')}</h5>
                <FormGroup>
                    <label htmlFor="public">{t('blockchain.cert')}</label>
                    <Input type="file" name="public" accept=".cer"></Input>
                </FormGroup>

                <FormGroup>
                    <label htmlFor="private">{t('blockchain.key')}</label>
                    <Input type="file" name="private" accept=".key"></Input>
                </FormGroup>

                <FormGroup>
                    <label htmlFor="password">{t('blockchain.password')}:</label>
                    <input className="form-control" name="password" type="text"></input>
                </FormGroup>

                <div className="mt-3">
                    <Button block type="submit" disabled={isLoading}>
                        <i className={clsx('fas fa-circle-notch fa-spin', isLoading || 'd-none')}></i>
                        {t('blockchain.create_btn')}
                    </Button>
                </div>
            </form>

            <div className="mt-5">
                <p><b>{t('ó Ingresa tu dirección')}</b></p>
                <input type="text" name="address" className="form-control mt-2" ref={address}></input>
                <Button block className="mt-3" onClick={importAddress}>{t('Importar')}</Button>
            </div>
        </div>
    )
}